import { Billboard, Plane } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import { useStore } from "effector-react";
import { useEffect, useState } from "react";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { AddReadenModelSlide } from "../../GuideButtons/logic/GuideLogic";
import { $modelPage } from "../../../hooks";
import "../../Modal/styles/button.css";

interface IClickMesh {
  posX: number;
  posY: number;
  posZ: number;
  scaleX: number;
  scaleY: number;
  scaleZ: number;
  title: string;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
  setSelectedHover?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ClickMesh = ({
  posX,
  posY,
  posZ,
  setSelected,
  title,
  scaleX,
  scaleY,
  scaleZ,
  setSelectedHover,
}: IClickMesh) => {
  const onClick = () => {
    try {
      setSelectedHover!(true);
    } catch {}
    setSelected(title);
    AddReadenModelSlide();
  };
  const [hovered, setHovered] = useState(false);

  const modelPage = useStore($modelPage);

  useEffect(() => {
    document.body.style.cursor = hovered ? "pointer" : "auto";
  }, [hovered]);
  const [colorMap2] = useLoader(TextureLoader, ["../Sicon.png"]);
  const [colorMap3] = useLoader(TextureLoader, ["../Qicon.png"]);
  return (
    <group>
      <mesh
        onClick={onClick}
        position={[posX, posY, posZ]}
        scale={[4, 4, 4]}
        onPointerOver={() => setHovered(true)}
        onPointerOut={() => setHovered(false)}
      >
        {
          //@ts-ignore
          <Billboard
            lockX={false}
            lockY={false}
            lockZ={false}
            position={[posX + 0.2, posY - 0.1, posZ + 0.02]}
            scale={[scaleX, scaleY, scaleZ]}
          >
            {
              //@ts-ignore
              <Plane args={[1, 1, 1]}>
                <circleBufferGeometry args={[2, 30]} />
                <meshBasicMaterial
                  toneMapped={false}
                  attach="material"
                  color="white"
                  opacity={1}
                  transparent
                  map={modelPage ? colorMap2 : colorMap3}
                />
              </Plane>
            }
          </Billboard>
        }
      </mesh>
    </group>
  );
};
